/**
 * @name spell-check
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMjAgMTUtNS41IDUuNUwxMiAxOCIgLz4KICA8cGF0aCBkPSJtNCAxNiA2LTEyIDUuMTE1IDEwLjIzIiAvPgogIDxwYXRoIGQ9Ik02IDEyaDgiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/spell-check
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const SpellCheck: string = `
<svg
  class="lucide lucide-spell-check"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="m20 15-5.5 5.5L12 18" />
  <path d="m4 16 6-12 5.115 10.23" />
  <path d="M6 12h8" />
</svg>
`;

export default SpellCheck;
